import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store'
import Login from '@/components/Login'
import loginMe from '@/components/loginMe'
import Home from '@/components/home/home'
import Setpsd from '@/components/home/setpsd'
import resetPwd from '@/components/home/resetPwd'
// 二维码
import Qrcode from '@/components/qrcode/code'

// 基础数据中心
import basicDataCenter from '@/components/basicDataCenter/basicDataCenter'
import basicInfo from '@/components/basicDataCenter/baseInfo'
import baseAdd from '@/components/basicDataCenter/baseAdd'
import baseServ from '@/components/basicDataCenter/baseServ'
import memDetails from '@/components/basicDataCenter/memDetails'
import addMems from '@/components/basicDataCenter/addmems'
import resetPsd from '@/components/basicDataCenter/resetPsd'
import setPsd from '@/components/basicDataCenter/setPsd'
import healthRecord from '@/components/basicDataCenter/healthRecord'
import employeeBasicInfo from '@/components/basicDataCenter/employeeBasicInfo'
import addStaff from '@/components/basicDataCenter/addStaff'
import editStaff from '@/components/basicDataCenter/editStaff'
import staffDetails from '@/components/basicDataCenter/staffDetails'
import partTechnician from '@/components/basicDataCenter/partTechnician'
import accountAndAuthority from '@/components/basicDataCenter/accountAndAuthority'
import trainRegistration from '@/components/basicDataCenter/trainRegistration'
import manualFee from '@/components/basicDataCenter/manualFee'
import extractFee from '@/components/basicDataCenter/extractFee'
import rewardFee from '@/components/basicDataCenter/rewardFee'
import todoorFee from '@/components/basicDataCenter/todoorFee'
import achievementFee from '@/components/basicDataCenter/achievementFee'
import storeBasicInfo from '@/components/basicDataCenter/storeBasicInfo'
import printSetup from '@/components/basicDataCenter/printSetup'
import printTicket from '@/components/basicDataCenter/printTicket'
import discount from '@/components/basicDataCenter/discount'
import addPartmem from '@/components/basicDataCenter/addPartmem'
import payAndAuthority from '@/components/basicDataCenter/payAndAuthority'
// 业务管理中心
import businessManagementCenter from '@/components/businessManagementCenter/businessManagementCenter'
import financeManageCenter from '@/components/businessManagementCenter/financeManageCenter'
import voucher from '@/components/businessManagementCenter/voucher'
import addVoucher from '@/components/businessManagementCenter/addVoucher'
import voucherDetail from '@/components/businessManagementCenter/voucherDetail'
import service from '@/components/businessManagementCenter/service'
import addService from '@/components/businessManagementCenter/addService'
// import proMaintain from '@/components/businessManagementCenter/proMaintain'
import campaign from '@/components/businessManagementCenter/campaign'
import order from '@/components/businessManagementCenter/order'
import orderDetail from '@/components/businessManagementCenter/orderDetail'
import serviceList from '@/components/businessManagementCenter/serviceList'
import serviceDetail from '@/components/businessManagementCenter/servicetoDetail'
import returnList from '@/components/businessManagementCenter/returnList'
import memRecharge from '@/components/businessManagementCenter/memRecharge'
import stock from '@/components/businessManagementCenter/stock'
import substock from '@/components/businessManagementCenter/substock'
import purchase from '@/components/businessManagementCenter/purchase'
import inventory from '@/components/businessManagementCenter/inventory'
import addInventory from '@/components/businessManagementCenter/addInventory'
import inventorView from '@/components/businessManagementCenter/inventorView'
import reconciliations from '@/components/businessManagementCenter/reconciliations'
import settlement from '@/components/businessManagementCenter/settlement'
import retailgoods from '@/components/businessManagementCenter/retailgoods'
import addGoods from '@/components/businessManagementCenter/addGoods'
import fictitious from '@/components/businessManagementCenter/fictitious'
import addFictite from '@/components/businessManagementCenter/addFictite'
// 报表中心
import cashConcession from '@/components/businessManagementCenter/cashConcession'
import staffSale from '@/components/businessManagementCenter/staffSale'
import sfaffService from '@/components/businessManagementCenter/sfaffService'
import cashFlow from '@/components/businessManagementCenter/cashFlow'
import todoorForm from '@/components/businessManagementCenter/todoorForm'
import manualcostForm from '@/components/businessManagementCenter/manualcostForm'
import memServiceForm from '@/components/businessManagementCenter/memServiceForm'
import royaltyPersonSum from '@/components/businessManagementCenter/royaltyPersonSum'
import royaltyTeamSum from '@/components/businessManagementCenter/royaltyTeamSum'
import summaryDetail from '@/components/businessManagementCenter/summaryDetail'
import memServiceDetail from '@/components/businessManagementCenter/memServiceDetail'
import returnMoneyList from '@/components/businessManagementCenter/returnMoneyList'
import returnRechargeList from '@/components/businessManagementCenter/returnRechargeList'
import accountStatiste from '@/components/businessManagementCenter/accountStatiste'

// 仪器保修
import instrument from '@/components/instrument/instrument'
// 工作台
import operatingFloor from '@/components/operatingFloor/operatingFloor'
import collection from '@/components/operatingFloor/collection'
import openOrder from '@/components/operatingFloor/openOrder'

import reportCenter from '@/components/reportCenter/reportCenter'
// 老板账号
import bossCenter from '@/components/bossCenter/bossCenter'
import allStore from '@/components/bossCenter/allStore'

//购物商城+
import shopping from '@/components/shoppingMall/shopping'
import shoppingIndex from '@/components/shoppingMall/shoppingIndex'
import shoppingProduct from '@/components/shoppingMall/shoppingProduct'
import shoppingInstrument from '@/components/shoppingMall/shoppingInstrument'
import shoppingMateriel from '@/components/shoppingMall/shoppingMateriel'
import shoppingMeal from '@/components/shoppingMall/shoppingMeal'
import shoppingConfigure from '@/components/shoppingMall/shoppingConfigure'
import shoppingDetail from '@/components/shoppingMall/shoppingDetail'
import shoppingSubmit from '@/components/shoppingMall/shoppingSubmit'
import shoppingCar from '@/components/shoppingMall/shoppingCar'
import shoppingMyOrders from '@/components/shoppingMall/shoppingMyOrders'
import shoppingOrderDetail from '@/components/shoppingMall/shoppingOrderDetail'
import shoppingAfterCustomer from '@/components/shoppingMall/shoppingAfterCustomer'
import shoppingAfterDetail from '@/components/shoppingMall/shoppingAfterDetail'
import shoppingSearch from '@/components/shoppingMall/shoppingSearch'
//集团业务
import cliqueBusinessCenter from '@/components/groupWork/cliqueBusinessCenter'
import cliqueWork from '@/components/groupWork/cliqueWork'
import addApply from '@/components/groupWork/addApply'
import cliqueDtails from '@/components/groupWork/cliqueDtails'


Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/',
      // name: 'Login',
      component: Login,
    }, {
      path: '/login',
      // name: 'Login',
      component: Login,
    }, {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    }, {
      path: '/setpsd',
      name: 'Setpsd',
      component: Setpsd,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        parent:'Setpsd'
      },
    },
    {
      path: '/basicDataCenter',
      name: 'basicDataCenter',
      component: basicDataCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/basicDataCenter/baseInfo',
      children: [{
        path: '/basicDataCenter/baseInfo',
        name: '查询会员',
        component: basicInfo,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          parent:'baseInfo',
        },
      },
      {
        path: '/basicDataCenter/addmems',
        name: '添加会员',
        component: addMems,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          // parent:'baseInfo',
        },
      },{
        path: '/basicDataCenter/memId=:memId',
        name: '修改会员',
        component: addMems,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          edit:'editmems'
        },
      },{
        path: '/basicDataCenter/baseAdd',
        name: '批量导入会员 ',
        component: baseAdd,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },{
        path: '/basicDataCenter/baseSer=:memberPhone',
        name: '服务剩余',
        component: baseServ,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },{
        path: '/basicDataCenter/resetPsd',
        name: '重置消费密码',
        component: resetPsd,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },{
        path: '/basicDataCenter/setPsd',
        name: '设置消费密码',
        component: setPsd,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },{
        path: '/basicDataCenter/id=:id',
        name: '会员详情',
        component: memDetails,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },{
        path: '/basicDataCenter/phone:phone',
        name: '系统会员详情',
        component: memDetails,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
      },
        {
          path: '/basicDataCenter/healthRecord',
          name: '会员健康档案',
          component: healthRecord,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'healthRecord',
          }
        },{
          path: '/basicDataCenter/employeeBasicInfo',
          name: '查询员工',
          component: employeeBasicInfo,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'employeeBasicInfo',
          }
        },{
          path: '/basicDataCenter/addStaff',
          name: '添加员工',
          component: addStaff,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'employeeBasicInfo',
          }
        },{
          path: '/basicDataCenter/staffid=:id',
          name: '修改员工',
          component: editStaff,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },{
          path: '/basicDataCenter/staffView=:id',
          name: '员工详情',
          component: staffDetails,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },{
          path: '/basicDataCenter/partTechnician',
          name: '兼职调理师管理',
          component: partTechnician,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'partTechnician',
          }
        },{
          path: '/basicDataCenter/accountAndAuthority',
          name: '员工权限分配',
          component: accountAndAuthority,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'accountAndAuthority',
          }
        },{
          path: '/basicDataCenter/payAndAuthority',
          name: '结算权限设置',
          component: payAndAuthority,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'payAndAuthority',
          }
        },{
          path: '/basicDataCenter/trainRegistration',
          name: '培训报名',
          component: trainRegistration,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'trainRegistration',
          }
        },{
          path: '/basicDataCenter/manualFee',
          name: store.state.userInfo.brandId == 1 ? '产后手工费配置':'儿推手工费配置',
          component: manualFee,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'manualFee',
          }
        },{
          path: '/basicDataCenter/extractFee',
          name: '销售提成',
          component: extractFee,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'extractFee',
          }
        },{
          path: '/basicDataCenter/rewardFee',
          name: '服务奖励',
          component: rewardFee,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'rewardFee',
          }
        },{
          path: '/basicDataCenter/todoorFee',
          name: '上门服务费',
          component: todoorFee,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'todoorFee',
          }
        },{
          path: '/basicDataCenter/achievementFee',
          name: '业绩提成设置',
          component: achievementFee,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'achievementFee',
          }
        },
        {
          path: '/basicDataCenter/storeBasicInfo',
          name: '门店基础信息',
          component: storeBasicInfo,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'storeBasicInfo',
          }
        },{
          path: '/basicDataCenter/printSetup',
          name: '小票设置',
          component: printSetup,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'printSetup',
          }
        },{
          path: '/basicDataCenter/printTicket',
          name: '服务单小票',
          component: printTicket,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },{
          path: '/basicDataCenter/discount',
          name: '折扣口令设置',
          component: discount,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'discount',
          }
        },{
          path: '/basicDataCenter/addPartmem',
          name: '添加兼职调理师',
          component: addPartmem,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/basicDataCenter/editPartmem/:id',
          name: '修改兼职调理师',
          component: addPartmem,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },{
          path: '/basicDataCenter/viewPartmem/:id',
          name: '查看兼职调理师',
          component: addPartmem,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }
      ]
    },{
      path: '/businessManagementCenter',
      name: 'businessManagementCenter',
      component: businessManagementCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/businessManagementCenter/voucher',
      children: [{
        path: '/businessManagementCenter/voucher',
        name: '查询商品',
        component: voucher,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          parent:'voucher'
        }
      },{
        path: '/businessManagementCenter/addVoucher=:type',
        name: '新增体验券',
        component: addVoucher,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          // parent:'voucher',
        }
      },{
        path: '/businessManagementCenter/editid:id',
        name: '修改体验券',
        component: addVoucher,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          edit:'editVoucher'
        }
      },{
        path: '/businessManagementCenter/copyid:id',
        name: '复制体验券',
        component: addVoucher,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          copy:'copyVoucher'
        }
      },{
        path: '/businessManagementCenter/viewid:id',
        name: '体验券详情',
        component: voucherDetail,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      },
        {
          path: '/businessManagementCenter/service',
          name: '商品列表',
          component: service,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'service'
          }
        },{
          path: '/businessManagementCenter/addService=:type',
          name: '新增服务商品',
          component: addService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            // parent:'service'
          }
        },{
        path: '/businessManagementCenter/editService:id',
        name: '修改服务商品',
        component: addService,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          edit:'editService'
        }
      },
        // {
        //   path: '/businessManagementCenter/maintain:id',
        //   name: '商品维护',
        //   component: proMaintain,
        //   meta: {
        //     requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        //   }
        // },
        {
          path: '/businessManagementCenter/campaign',
          name: '营销活动管理',
          component: campaign,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'campaign'
          }
        },
        {
          path: '/businessManagementCenter/stock',
          name: '服务类商品',
          component: stock,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'stock'
          }
        },{
          path: '/businessManagementCenter/substock:id',
          name: '商品入库',
          component: substock,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            // parent:'stock'
          }
        },{
          path: '/businessManagementCenter/purchase',
          name: '采购报货',
          component: purchase,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'purchase'
          }
        },{
          path: '/businessManagementCenter/inventory',
          name: '库存盘点',
          component: inventory,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'inventory'
          }
        },{
          path: '/businessManagementCenter/addInventory',
          name: '新增盘点单',
          component: addInventory,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'inventory'
          }
        },{
          path: '/businessManagementCenter/inventorView/:id',
          name: '盘点单详情',
          component: inventorView,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'inventory'
          }
        },{
          path: '/businessManagementCenter/reconciliations',
          name: '账款对账',
          component: reconciliations,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'reconciliations'
          }
        },{
          path: '/businessManagementCenter/settlement',
          name: '结算',
          component: settlement,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'settlement'
          }
        },{
          path: '/businessManagementCenter/retailgoods',
          name: '零售商品管理',
          component: retailgoods,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'retailgoods'
          }
        },{
          path: '/businessManagementCenter/retailService',
          name: '新增零售商品',
          component: addService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },{
          path: '/businessManagementCenter/retailEdit:id',
          name: '修改零售商品',
          component: addService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            edit:'retailEdit'
          }
        },{
          path: '/businessManagementCenter/addGoods',
          name: '添加商品',
          component: addGoods,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            add:'addGoods'
          }
        },{
          path: '/businessManagementCenter/editGoods:id',
          name: '编辑商品',
          component: addGoods,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            edit:'editGoods'
          }
        },{
          path: '/businessManagementCenter/viewGoods:id',
          name: '查看商品',
          component: addGoods,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            view:'viewGoods'
          }
        },
        {
          path: '/businessManagementCenter/fictitious',
          name: '商品管理',
          component: fictitious,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'fictitious'
          }
        },
        {
          path: '/businessManagementCenter/addFictite=:type',
          name: '新增商品管理',
          component: addService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/businessManagementCenter/editFictite:id',
          name: '编辑商品管理',
          component: addService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            edit:'editFictite'
          }
        },
        {
          path: '/businessManagementCenter/addTimeCard=:type',
          name: '新增商品管理 ',
          component: addFictite,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/businessManagementCenter/editTimeCard:id',
          name: '编辑商品管理 ',
          component: addFictite,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            edit:'editTimeCard'
          }
        }
      ]
    },
    {
      path: '/instrument',
      name: 'instrument',
      component: instrument,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        parent:'instrument',
        isCollapse:true
      },
    },{
      path: '/operatingFloor',
      name: 'operatingFloor',
      component: operatingFloor,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/operatingFloor/openOrder',
      children: [{
        path: '/operatingFloor/openOrder',
        name: '操作台',
        component: openOrder,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        }
      },{
        path: '/operatingFloor/collection',
        name: '收银台',
        component: collection,
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          parent:'operatingFloor'
        }
      }]
    },
    {
      path: '/reportCenter',
      name: 'reportCenter',
      component: reportCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    },
    {
      path: '/resetPwd/:tel',
      name: 'resetPwd',
      component: resetPwd,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        parent:'resetPwd'
      },
    },{
      path: '/shoppingMall',
      name: 'shoppingMall',
      component: shopping,
      meta: {
        requireAuth: true,
      },
      redirect: '/shoppingMall/index',
      children:[{
        path: '/shoppingMall/index',
        name: '购物商城',
        component: shoppingIndex,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingCar',
        name: '购物车',
        component: shoppingCar,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingProduct',
        name: '产品',
        component: shoppingProduct,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingInstrument',
        name: '仪器',
        component: shoppingInstrument,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingMateriel',
        name: '物料',
        component: shoppingMateriel,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingMeal',
        name: '套餐',
        component: shoppingMeal,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingConfigure',
        name: '配置',
        component: shoppingConfigure,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingDetail/:id',
        name: '产品详情',
        component: shoppingDetail,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingSubmit',
        name: '提交订单',
        component: shoppingSubmit,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingMyOrders',
        name: '我的订单',
        component: shoppingMyOrders,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingOrderDetail/:id',
        name: '订单详情1',
        component: shoppingOrderDetail,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingAfterCustomer',
        name: '售后中心',
        component: shoppingAfterCustomer,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingAfterDetail/:id',
        name: '售后详情',
        component: shoppingAfterDetail,
        meta: {
          requireAuth: true
        }
      },{
        path: '/shoppingMall/shoppingSearch',
        name: '商品查询',
        component: shoppingSearch,
        meta: {
          requireAuth: true
        }
      }]
    },
    {
      path: '/bossCenter',
      name: '营收监控',
      component: bossCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
    },{
      path: '/allStore',
      name: '所有门店',
      component: allStore,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path:'/qrcode/:id',
      name:'qrcode',
      component: Qrcode,
    },{
      path:'/financeManageCenter',
      name: 'financeManageCenter',
      component: financeManageCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/financeManageCenter/cashConcession',
      children:[
        {
          path: '/financeManageCenter/order',
          name: '订单查询',
          component: order,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'order'
          }
        }
        ,{
          path: '/financeManageCenter/orderDetail:orderid',
          name: '订单详情',
          component: orderDetail,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            isCollapse:true
          },
        }
        ,{
          path: '/financeManageCenter/serviceList',
          name: '服务单查询',
          component: serviceList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'serviceList'
          }
        },{
          path: '/financeManageCenter/serviceDetail:id',
          name: '服务单详情',
          component: serviceDetail,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            isCollapse:true
          }
        },{
          path: '/financeManageCenter/returnList',
          name: '退货单查询',
          component: returnList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'returnList'
          }
        },{
          path: '/financeManageCenter/memRecharge',
          name: '会员充值明细',
          component: memRecharge,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'memRecharge'
          }
        },{
          path: '/financeManageCenter/cashConcession',
          name: '收银员让利',
          component: cashConcession,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'cashConcession'
          }
        },{
          path: '/financeManageCenter/staffSale',
          name: '员工销售统计',
          component: staffSale,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'staffSale'
          }
        },{
          path: '/financeManageCenter/sfaffService',
          name: '员工服务消耗业绩',
          component: sfaffService,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'sfaffService'
          }
        },{
          path: '/financeManageCenter/cashFlow',
          name: '对账总计',
          component: cashFlow,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'cashFlow'
          }
        },{
          path: '/financeManageCenter/todoorForm',
          name: '上门费明细报表',
          component: todoorForm,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'todoorForm'
          }
        },
        {
          path: '/financeManageCenter/manualcostForm',
          name: '手工费明细报表',
          component: manualcostForm,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'manualcostForm'
          }
        },{
          path: '/financeManageCenter/memServiceForm',
          name: '会员服务明细报表',
          component: memServiceForm,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'memServiceForm'
          }
        },
        {
          path: '/financeManageCenter/royaltyPersonSum',
          name: '提成费用汇总（个人）',
          component: royaltyPersonSum,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'royaltyPersonSum'
          }
        },{
          path: '/financeManageCenter/royaltyTeamSum',
          name: '提成费用汇总（团队）',
          component: royaltyTeamSum,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'royaltyTeamSum'
          }
        },{
          path: '/financeManageCenter/summaryDetail',
          name: '查看提成费用汇总',
          component: summaryDetail,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            isCollapse:true
          }
        },{
          path: '/financeManageCenter/memServiceDetail/:id/:tel',
          name: '会员服务明细详情',
          component: memServiceDetail,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            isCollapse:true
          }
        },
        {
          path: '/financeManageCenter/returnMoneyList',
          name: '销售退款明细报表',
          component: returnMoneyList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'returnMoneyList'
          }
        },{
          path: '/financeManageCenter/returnRechargeList',
          name: '充值退款明细报表',
          component: returnRechargeList,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'returnRechargeList'
          }
        },{
          path: '/financeManageCenter/accountStatiste',
          name: '对账统计',
          component: accountStatiste,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'accountStatiste'
          }
        }
      ]
    }, {
      path: '/loginMe',
      name: 'loginMe',
      component: loginMe
    },
    {
      path:'/cliqueBusinessCenter',
      name: 'cliqueBusinessCenter',
      component: cliqueBusinessCenter,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      redirect: '/cliqueBusinessCenter/cliqueWork',
      children:[
        {
          path: '/cliqueBusinessCenter/cliqueWork',
          name: '查询申请',
          component: cliqueWork,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'cliqueWork'
          }
        },{
          path: '/cliqueBusinessCenter/addApply',
          name: '新增申请',
          component: addApply,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            parent:'cliqueWork'
          }
        },{
          path: '/cliqueBusinessCenter/cliqueDtails=:id',
          name: '查看详情',
          component: cliqueDtails,
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          }
        }
      ]
    },
  ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js